var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon
    ? _c(
        "dl",
        {
          staticClass:
            "icon-details-glyphs display-inline-flex flex-items-center",
          staticStyle: {
            "--button-margin-bottom": "0",
            "--button-background": "transparent",
            "--button-hover-background": "transparent",
            "--button-hover-color": "var(--fa-dk-blue)",
            "--button-active-color": "var(--fa-dk-blue)",
            "--margin-bottom": "0",
            "--padding-left": "0",
            gap: "var(--spacing-4xs)",
          },
        },
        [
          !(_vm.isDuotone && _vm.isCustomIcon)
            ? _c(
                "dt",
                {
                  staticClass: "muted sr-only",
                  staticStyle: {
                    "--margin-bottom": "0",
                    "font-weight": "var(--font-weight-normal)",
                  },
                },
                [_vm._v("\n    " + _vm._s(_vm.glyphLabel) + ":\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("dd", { staticStyle: { "--margin-bottom": "0" } }, [
            _c(
              "button",
              {
                staticClass:
                  "icon-action-glyph-copy flat compact display-inline-block padding-x-2xs",
                staticStyle: { "--button-color": "var(--fa-navy)" },
                attrs: {
                  type: "button",
                  "aria-label": `${
                    _vm.isDuotone
                      ? _vm.justCopied === "primaryglyph"
                        ? "Copied"
                        : "Copy Primary Layer"
                      : _vm.justCopied === "primaryglyph"
                      ? "Copied"
                      : "Copy Glyph"
                  }`,
                  "data-balloon-pos": "up",
                },
                on: { click: _vm.copyPrimaryGlyph },
              },
              [
                !_vm.isCustomIcon
                  ? _c("span", [
                      _c("i", {
                        class: [
                          `${_vm.translatedStyle} fa-${_vm.icon.name} fa-lg fa-fw`,
                        ],
                        staticStyle: { "--fa-secondary-opacity": "0.1" },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCustomIcon && !_vm.isDuotone
                  ? _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          staticStyle: { "--fa-secondary-opacity": "0.1" },
                          attrs: {
                            icon: _vm.iconDefinition,
                            size: "lg",
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Copy Glyph")]),
              ]
            ),
            _vm._v(" "),
            _vm.isDuotone
              ? _c(
                  "button",
                  {
                    staticClass:
                      "icon-action-glyph-secondary-copy flat compact display-inline-block padding-x-2xs",
                    staticStyle: { "--button-color": "var(--fa-navy)" },
                    attrs: {
                      type: "button",
                      "aria-label":
                        _vm.justCopied === "secondaryglyph"
                          ? "Copied"
                          : "Copy Secondary Layer",
                      "data-balloon-pos": "up",
                    },
                    on: { click: _vm.copySecondaryGlyph },
                  },
                  [
                    !_vm.isCustomIcon
                      ? _c("span", [
                          _c("i", {
                            class: [
                              `${_vm.translatedStyle} fa-${_vm.icon.name} fa-lg fa-fw`,
                            ],
                            staticStyle: {
                              "--fa-secondary-opacity": "1",
                              "--fa-primary-opacity": "0.1",
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Copy Secondary Glyph"),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }